(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }

  var collection = {
    internalSelections: {}, // Internal storage for name:value pairs
    fillterClick: false,

    init: function() {
      this.initCollectionFilter();
      this.initCollectionShow();
      this.initCollectionSorting();
      this.initRemoveAllFilters();
    },

    fillterTagEvents: function() {
      $("body").delegate('.filter-tag a:not(".clear"), .filter-tag label', 'click', function(e) {
        e.preventDefault();

        var $this = $(this);
        var nameAttr = $this.prev().attr('name');
        
        // Remove active class from all parents of checkboxes with the same name attribute
        if (nameAttr) {
          $(".filter-tag input[name='" + nameAttr + "']").each(function() {
            $(this).closest('.filter-tag').removeClass('active');
            $(this).closest('.filter-tag').find('a').removeClass('active');
          });
        }

        // Toggle active class for the clicked element
        var $parentTag = $this.closest('.filter-tag');
        if ($this.hasClass('active')) {
          $this.removeClass('active');
          $parentTag.removeClass('active');
        } else {
          $this.addClass('active');
          $parentTag.addClass('active');
        }

        // Update internal selections
        var tagValue = $this.prev().val();
        if (nameAttr) {
          if ($this.hasClass('active')) {
            collection.internalSelections[nameAttr] = tagValue;
          } else {
            delete collection.internalSelections[nameAttr];
          }
        }

        // Update the constraint parameter with only unique values
        var currentTags = Object.values(collection.internalSelections);
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
      });
    },

    initRemoveAllFilters: function() {
      $("body").delegate('a.remove-all-filters', 'click', function(e) {
        e.preventDefault();

        // Clear all checkboxes
        $('.filter-tag input:checked').prop('checked', false);
        // Remove active class from filter tags
        $('.filter-tag').removeClass('active');
        $('.filter-tag a').removeClass('active');

        // Clear URL parameters
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        collection.internalSelections = {}; // Clear internal selections
        collection.filterAjaxClick();
      });
    },

    filterMapClearAll: function() {
      // Clear all selections
      $("body").delegate('click', '.refined-widgets a.clear-all', function(e) {
        collection.internalSelections = {};
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        collection.filterAjaxClick();
        e.preventDefault();
      });

      $("body").delegate('.filter-block .clear', 'click', function(e) {
        var filterTag = $(this).parent().parent();
        var tagNameAttr = filterTag.find("input:checked").attr('name');
        
        // Remove all selections for this filter block
        if (tagNameAttr) {
          delete collection.internalSelections[tagNameAttr];
          filterTag.find("a").removeClass("active");
          filterTag.removeClass("active");
        }

        // Update the constraint parameter
        var currentTags = Object.values(collection.internalSelections);
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          // Has active tag
          filterTag.find(".clear").show();
        }
      });
    },

    filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    filterMapEvents: function() {
      collection.fillterTagEvents();
    },

    resetFilter: function() {
      $(".filter-custom .active, .filter-links .active").removeClass("active");
      $(".filter-tag input:checked").attr("checked", false);

      // Category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".filter-links a[href='" + cat[0] + "']").addClass("active");
      }
    },

    filterMapData: function(data) {
      var currentList = $(".product-collection-grid");
      var productList = $(data).find(".product-collection-grid");

      currentList.replaceWith(productList);

      // Replace paging
      if ($(".pagination").length > 0) {
        $(".pagination").replaceWith($(data).find(".pagination"));
      }

      $('.filter-blocks').replaceWith($(data).find(".filter-blocks"));
      collection.filterMapClear();
    },

    filterCreateUrl: function(baseLink) {
      // Ensure no %3 is in the URL
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {
        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {
      $.ajax({
        type: 'get',
        url: newurl,
        enctype: 'multipart/form-data',
        beforeSend: function() {
          showPopup('.loading');
        },

        success: function(data) {
          collection.filterMapData(data);
          collection.filterMapClear();
          hidePopup('.loading');
        },

        error: function(xhr, text) {
          hidePopup('.loading')
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }
      });
    },

    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".wrap-filter-sorting li a").click(function(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();

          $(".wrap-filter-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }
        var selected = $(this).text();
        $(this).closest('.filter').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-toggle').removeClass('active');
      });
    },

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {
      // Implementation for view mode if needed
    },

    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {
      $(".filter-show a").click(function(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          var currentPage = $(this).attr('href');
          var view = $(".button-view a.active").attr("data-mode");
          if (view == "list") {
            Shopify.queryParams.view = "list" + currentPage;
          } else {
            Shopify.queryParams.view = currentPage;
          }
          collection.filterAjaxClick();
          $(".filter-show li.active").removeClass("active");
          $(this).parent().addClass("active");
          $(this).closest('.dropdown').find('.dropdown-label').text(currentPage);
          $(this).closest('.dropdown-content').removeClass('active');
        }
      });
    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {
      // Implementation for paging if needed
    },

  }

})(jQuery);
